import React from 'react';

export type EventScheduleItemProps = {
  name: string;
  description: string;
};

const EVENT_SCHEDULE_DATES: Record<number, string> = {
  23: '11月30日（日）',
  24: '12月06日（土）',
  25: '12月13日（土）'
};

const EventScheduleItem: React.FC<EventScheduleItemProps> = ({
  name,
  description
}) => (
  <tr>
    <td className='px-4 py-2 border border-white bg-[#DEF0EF]'>{name}</td>
    <td className='px-4 py-2 whitespace-pre-wrap'>{description}</td>
  </tr>
);

const EventScheduleTable: React.FC<{
  schedule?: Array<EventScheduleItemProps>;
  pageId?: number;
}> = ({ schedule, pageId }) => {
  if (!schedule?.length) return null;
  const scheduleDate = pageId ? EVENT_SCHEDULE_DATES[pageId] : undefined;
  
  return (
    <div className='flex flex-col mt-5'>
      <div className='text-[#333333] whitespace-pre-wrap w-full flex text-left items-center justify-start text-[16px]'>
        ● イベントスケジュール
      </div>
      {scheduleDate && (
        <div className='text-[#333333] whitespace-pre-wrap w-full flex text-left items-center justify-start text-[16px] mt-1'>
          {scheduleDate}
        </div>
      )}
      <table className='w-full text-left mt-2'>
        {schedule?.map(({ name, description }) => (
          <EventScheduleItem name={name} description={description} />
        ))}
      </table>
    </div>
  );
};

export default EventScheduleTable;
